import axios from 'axios';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

const useCharity = () => {
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalDonations, setTotalDonations] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async function () {
      try {
        setLoading(true);
        const { data } = await axios.get('/api/charity/total');
        setTotalAmount(data.totalAmount);
        setTotalDonations(data.totalDonations);
      } catch (error) {
        console.error(error);
        toast.error('Unable to fetch charity total');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return {
    totalAmount,
    totalDonations,
    loading,
  };
};

export default useCharity;
